module.exports = __webpack_public_path__ + "img/unsecured_mobile_bg.2748a3eb.jpg";